// removed by extract-text-webpack-plugin
module.exports = {"BuildControls":"BuildControls__BuildControls__1Lo7l","OrderButton":"BuildControls__OrderButton__AGmAM","enable":"BuildControls__enable__186BI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuidControls/BuildControls.css
// module id = 62
// module chunks = 0